// Deletes every Cache Storage entry whose name starts with `api-` (the one runtime cache
// this app configures is `api-goals`, see vite.config.js's VitePWA `runtimeCaching`).
// Called on every exit path that ends a session (see stores/auth.js `logout` and
// `handleUnauthorized`, and ProfileView.vue's `confirmDelete`) so a signed-out or deleted
// account never leaves cached personal data behind for the next person to use this device.
//
// Deliberately best-effort: `caches` is absent in any non-secure context (not just Node --
// plain http:// origins too), and Cache Storage operations can fail for reasons entirely
// outside this app's control (private-browsing quota, browser bugs). None of that may ever
// block signing out, so every failure is swallowed here rather than propagated.
//
// Swallowed, but NOT silent. This is a privacy control: if it fails, personal data stays
// readable on a shared device. With no telemetry in this app, a console error is the only
// affordance left -- it costs nothing and it is the difference between a failure someone
// can find in devtools during a bug report and one that is undiscoverable by anyone, ever.
const API_CACHE_PREFIX = 'api-'

export async function purgeApiCaches() {
  const storage = globalThis.caches
  if (!storage) return
  try {
    const names = await storage.keys()
    await Promise.all(
      names
        .filter((name) => name.startsWith(API_CACHE_PREFIX))
        .map((name) =>
          storage.delete(name).catch((error) => {
            // eslint-disable-next-line no-console -- the only observability this app has
            console.error(`[purgeApiCaches] failed to delete cache "${name}"`, error)
            return false
          })
        )
    )
  } catch (error) {
    // eslint-disable-next-line no-console -- the only observability this app has
    console.error('[purgeApiCaches] could not enumerate Cache Storage', error)
  }
}
